module.exports = __webpack_public_path__ + "img/the-american-conservative.b585d993.png";